import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { QrCodeService } from "./qr-code.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LayoutPrintService } from "../layout-print/layout-print.service";
import { Router } from "@angular/router";
var QrCodeComponent = (function () {
    function QrCodeComponent(qrCodeService, layoutPrintService, differs, toastr, vcr, router) {
        this.qrCodeService = qrCodeService;
        this.layoutPrintService = layoutPrintService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.elementType = 'url';
        this.qrCode = {};
        this.modal = {};
        this.checkedAll = true;
        this.layoutPrintList = [];
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    QrCodeComponent.prototype.ngOnInit = function () {
        this.title = "QR Code";
        this.filterParams = {
            size: 5,
            page: 0
        };
        this.getLayoutPrintList();
        this.listPrint = new Array();
    };
    QrCodeComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getQrCodeList();
        }
    };
    QrCodeComponent.prototype.getLayoutPrintList = function () {
        var _this = this;
        this.isLoading = true;
        this.layoutPrintService.getLayoutPrintList({ page: 0, size: 20 })
            .then(function (res) {
            if (res.status === 1) {
                _this.layoutPrintList = res.data.dataList;
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    QrCodeComponent.prototype.getQrCodeList = function () {
        var _this = this;
        this.checkedAll = false;
        this.isLoading = true;
        this.qrCodeService.getQrCodeList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.qrCodeList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    QrCodeComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    QrCodeComponent.prototype.initModal = function (state, category) {
        if (category === void 0) { category = {}; }
        switch (state) {
            case 'create':
                {
                    this.modal = {
                        title: 'Generate Qr Code',
                        btnName: 'Create',
                        state: state
                    };
                    this.qrCode.productId = '';
                    this.qrCode.numberCode = '';
                }
                break;
        }
        $('#myModal').modal('show');
    };
    QrCodeComponent.prototype.onSubmit = function (formQrCode) {
        var _this = this;
        localStorage.removeItem('printData');
        switch (this.modal.state) {
            case 'create':
                {
                    this.qrCodeService.generateQrCode(formQrCode.value)
                        .then(function (res) {
                        if (res.status === 1) {
                            _this.getQrCodeList();
                            localStorage.setItem('printData', JSON.stringify(res.data));
                            _this.toastr.success('Generate ' + formQrCode.value.numberPerCode + ' QrCode.', 'Success!');
                            $('#myModal').modal('hide');
                        }
                        else {
                            _this.toastr.error(res.message, 'Error!');
                            if (res.errorCode === 3000) {
                                localStorage.setItem("alert", JSON.stringify(res.message));
                                _this.router.navigate(['login']);
                            }
                        }
                    })
                        .catch(function (err) { return console.log(err); });
                }
                break;
        }
        $('#selectLayout').modal('show');
    };
    QrCodeComponent.prototype.printQrCode = function (qrCode) {
        var printData = new Array();
        printData.push(qrCode);
        localStorage.setItem('printData', JSON.stringify(printData));
        $('#selectLayout').modal('show');
    };
    QrCodeComponent.prototype.openWindowPrint = function () {
        var left = (screen.width / 2) - (600 / 2);
        var top = (screen.height / 2) - (600 / 2);
        var path = 'print-qrcode';
        if (this.sizeQrcode === 'small') {
            path = 'print-qrcode-small';
        }
        window.open('#/' + path + '/' + this.selectedLayout, '_blank', 'width=600,height=600, top=' + top + ', left=' + left + ',scrollbars=no,menubar=no,toolbar=no,'
            + 'location=no,status=no,titlebar=no');
    };
    QrCodeComponent.prototype.printAll = function () {
        localStorage.setItem('printData', JSON.stringify(this.listPrint));
        $('#selectLayout').modal('show');
        var listId = [];
        this.listPrint = [];
        this.checkedAll = false;
    };
    QrCodeComponent.prototype.deleteQrCode = function (listId) {
        var _this = this;
        if (listId === void 0) { listId = []; }
        if (listId.length == 0) {
            this.listPrint.forEach(function (item) {
                listId.push(item.serialId);
            });
        }
        if (confirm("Confirm delete?")) {
            this.qrCodeService.deleteQrCode(listId)
                .then(function (res) {
                if (res.status === 1) {
                    _this.getQrCodeList();
                    _this.toastr.success('Deleted', 'Success!');
                    _this.listPrint = [];
                    _this.checkedAll = false;
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
            })
                .catch(function (err) { return console.log(err); });
        }
    };
    QrCodeComponent.prototype.setQrCodeUsed = function (listId, ckb) {
        var _this = this;
        this.qrCodeService.setUsedQrCode(listId, ckb.checked)
            .then(function (res) {
            if (res.status === 1) {
                _this.toastr.success('Setted!', 'Success!');
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    QrCodeComponent.prototype.checkChange = function (qrcode, ckb) {
        var index = this.listPrint.findIndex(function (i) { return i.serialId == qrcode.serialId; });
        if (ckb.checked == true && index == -1) {
            this.listPrint.push(qrcode);
        }
        else {
            this.listPrint.splice(index, 1);
        }
    };
    QrCodeComponent.prototype.checkAll = function (ckbAll) {
        var _this = this;
        this.checkedAll = ckbAll.checked;
        this.qrCodeList.forEach(function (item) {
            _this.checkChange(item, ckbAll);
        });
    };
    QrCodeComponent.prototype.isChecked = function (serialId) {
        var index = this.listPrint.findIndex(function (i) { return i.serialId == serialId; });
        if (index == -1)
            return false;
        return true;
    };
    return QrCodeComponent;
}());
export { QrCodeComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/qr-code/qr-code.component.ts.pre-build-optimizer.js